import { useEffect, useState } from "react";

import { EmptyComponent } from "../../components/common/EmptyComponent";
import Loadable from "react-loadable";
import { getCrossSellMobile, getCrossSellPC } from "./loader";
import { DeviceUtils } from "../../utils/deviceUtils";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../redux/selectors";
import { PageContextUtils } from "../../utils";

export const CrossActivity = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "crossactivity/pc/crossActivity" */ "./CrossActivity.pc"
    ),
  loading: EmptyComponent
});

export const MobileCrossActivity = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "crossactivity/mobile/crossActivity" */ "./CrossActivity.mobile"
    ),
  loading: EmptyComponent
});

let CrossSellPCPromise, CrossSellMobilePromise;

export const useCrossSellProps = crossActivityProps => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const { name } = PageContextUtils.getClientProviderData();
  const isSIC = DeviceUtils.isCasinoApp();
  const isPokerApp = DeviceUtils.isPokerApp();

  const [crossSellProps, setCrossSellProps] = useState(null);

  useEffect(() => {
    const getter = async () => {
      const getCrossSellFn = isMobile ? getCrossSellMobile : getCrossSellPC;
      const crossSellPromise = isMobile
        ? CrossSellMobilePromise
        : CrossSellPCPromise;
      const getCrossSell = await (crossSellPromise ??
        getCrossSellFn(brandId, name));

      if (typeof getCrossSell === "function") {
        setCrossSellProps(getCrossSell(crossActivityProps));
      }
    };

    if (!isSIC && !isPokerApp) {
      getter();
    }
  }, [brandId, crossActivityProps, isMobile, name, isSIC, isPokerApp]);

  return crossSellProps;
};
